export function objectToGetParams(object: { [key: string]: string | number | undefined | null }) {
  const params = Object.entries(object)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);

  return params.length > 0 ? `?${params.join('&')}` : '';
}

export function shareTemplate(media: string, shareParameter: string | undefined) {
  let shareLink = '';
  if (media === 'facebook') {
    shareLink = `https://www.facebook.com/sharer/sharer.php${shareParameter}`;
  }
  if (media === 'linkedin') {
    shareLink = `https://www.linkedin.com/shareArticle${shareParameter}`;
  }
  if (media === 'twitter') {
    shareLink = `https://twitter.com/intent/tweet${shareParameter}`;
  }
  if (media === 'email') {
    shareLink = `mailto:${shareParameter}`;
  }
  return shareLink;
}

export function openShareLink(media: string, url: string) {
  if (media === 'email') {
    window.location.href = url;
  } else {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }
}
